/* global jQuery */
jQuery(document).ready(function($) {
	
	/****************************************************************
		Touch Desktop Nav
	****************************************************************/
	$(document).on("click", ".touch .desktop-nav .nav-list .menu-item-has-children > a", function(e){
		var t = $(this);
		var parent = t.closest("li");
		
		if(parent.hasClass("active"))
		{
			parent.removeClass("active");
		} else {
			$(".touch .desktop-nav .nav-list .menu-item-has-children").removeClass("active");
			parent.addClass("active");
		}
		
		return false;
	});
	
	
	/****************************************************************
		Add 'overview' links
	****************************************************************/
	$(".desktop-nav .nav-list > li.menu-item-has-children").each(function(index, element) {
		var t = $(this);
		var $li = $("<li>");
	
		$li.addClass("desktop-nav-hide");
	
		//Messing up this selector (i.e. not having '>') results in the cloned item being removed from the DOM, weird.
		t.find("> a:first").clone().text("Overview").appendTo($li);			
		
		t.find("ul").prepend($li);
	});
	
	
	/****************************************************************
		Close mobile menu if only using anchor links on the same page
	****************************************************************/
	$(document).on("click", ".mobile-nav .nav-list > li a[href*='#']", function(e){
		var t = $(this);
		var href = t.attr("href")
		var root = $("html");
				
		if(href.indexOf(window.location.pathname) != -1)
		{
			root.toggleClass("mobile-nav-opened mobile-nav-closed");
		}
	});
	
	
	/****************************************************************
		Touch nav hide/show
	****************************************************************/
	$(document).on("click mobile-nav-view", ".event-mobile-nav-view", function(e){
	
		var root = $("html");
		
		if(root.hasClass("mobile-nav-closed"))
		{
			root.toggleClass("mobile-nav-closed mobile-nav-opened");
			ga_event({
				"category": "mobile nav",
				"action": "click",
				"label": "opened",
				"value": 1
			});
		} else if(root.hasClass("mobile-nav-opened")) {
			root.toggleClass("mobile-nav-opened mobile-nav-closed");
			ga_event({
				"category": "mobile nav",
				"action": "click",
				"label": "closed",
				"value": 1
			});
		}
	
		return false;
	});	
	
	
	/****************************************************************
		Click event for parent nav items in mobile nav
	****************************************************************/
	$(document).on("click", ".mobile-nav .nav-list > li.menu-item-has-children > a", function(e) {
		e.preventDefault();
		var t = $(this);
		var parent = t.closest("li");
		parent.toggleClass("mobile-nav-item-opened");
		
		ga_event({
			"category": "nav",
			"action": "click",
			"label": "children",
			"value": 1
		});
		
		return false;
	});

});